import config from '@/config'

export default {
	id: 'SIMPLE_PREMIUM_4W_44_1W_5_19',
	providers: {
		stripe: config('stripe_cheap_and_short'),
		braintree: 'pro_short_cheap',
		paltaMap: {
			USD: 'simple_premium_4w_44_1w_5_19_usd',
			EUR: 'simple_premium_4w_39_1w_5_19_eur',
			GBP: 'simple_premium_4w_44_1w_5_19_gbp',
			AUD: 'simple_premium_4w_73_1w_7_99_aud',
			CAD: 'simple_premium_4w_73_1w_7_99_cad',
			DKK: 'simple_premium_4w_379_1w_39_dkk',
			SEK: 'simple_premium_4w_585_1w_59_sek',
			NOK: 'simple_premium_4w_585_1w_59_nok',
			MXN: 'simple_premium_4w_729_1w_79_mxn',
			BRL: 'simple_premium_4w_99_1w_17_brl',
			TRY: 'simple_premium_4w_1499_1w_169_try',
			ARS: 'simple_premium_4w_58000_1w_6990_ars',
			COP: 'simple_premium_4w_178000_1w_20990_cop',
			CLP: 'simple_premium_4w_42000_1w_4990_clp',
		},
		primer: 'prd_b8shUSP1LQuo',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 1,
		intro_period_type: 'week',
		next_period_value: 4,
		next_period_type: 'week',
	},
	trial: {
		days: 7,
		priceMap: {
			USD: 5.19,
			EUR: 5.19,
			GBP: 5.19,
			AUD: 7.99,
			CAD: 7.99,
			DKK: 39,
			SEK: 59,
			NOK: 59,
			MXN: 79,
			BRL: 17,
			TRY: 169,
			ARS: 6990,
			COP: 20990,
			CLP: 4990,
		},
		originalPriceMap: {
			USD: 9.99,
			EUR: 9.99,
			GBP: 9.99,
			AUD: 15,
			CAD: 15,
			DKK: 69,
			SEK: 110,
			NOK: 110,
			MXN: 129,
			BRL: 55,
			TRY: 333,
			ARS: 12990,
			COP: 39990,
			CLP: 9990,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 1,
		priceMap: {
			USD: 44,
			EUR: 39,
			GBP: 44,
			AUD: 73,
			CAD: 73,
			DKK: 379,
			SEK: 585,
			NOK: 585,
			MXN: 729,
			BRL: 99,
			TRY: 1499,
			ARS: 58000,
			COP: 178000,
			CLP: 42000,
		},
	},
}
